import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { getQueryString } from '../../utils/queryString'

type TestOutcomesParams = {
  isCorrect?: boolean
  simulationMode?: string
  threshold?: string
}

export const useFetchAllTestOutcomes = (
  testId: number,
  params?: TestOutcomesParams
) => {
  const [testOutcomes, setTestOutcomes] = useState<string | undefined>()

  const location = useLocation()

  const loadTestOutcomes = useCallback(async () => {
    const queryString = getQueryString({
      trainingTest: testId,
      isCorrect: params?.isCorrect,
      simulation_mode: params?.simulationMode,
      threshold: params?.threshold,
    })

    get<string>(`/training_test_outcomes/graphs/?${queryString}`)
      .then((response) => {
        try {
          const responseAsJSONObject = JSON.parse(JSON.stringify(response))
          setTestOutcomes(responseAsJSONObject)
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(
            `Error in function useFetchAllTestOutcomes(testId=${testId}, params=${params}) with queryString=${queryString} ${e}`
          )
        }
      })
      .catch(handleApiErrors)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    testId,
    params?.isCorrect,
    testOutcomes,
    params?.threshold,
    params?.simulationMode,
  ])

  useEffect(() => {
    loadTestOutcomes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key])

  return {
    testOutcomes: testOutcomes || [],
  }
}
